import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import AccessControl from "../functional/AccessControl";
import CreateRecordButton from "../input/CreateRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import getSchema from "../../lib/api/getSchema";

import MomSysUdtCompanyExcelUploadButton from "../input/MomSysUdtCompanyExcelUploadButton";
import MomSysUdtCompanyExcelFormDownloadButton from "../input/MomSysUdtCompanyExcelFormDownloadButton";

import notificationState from "../../states/notificationState";

import { cloneDeep } from "lodash";

function MomSysUdtCompany ( props ) {
    const {id, masterGridSetting} = props;

    const [schema, setSchema] = useState();
    const [api, setApi] = useState();
    const [grid, setGrid] = useState();
    const [modifiedSchema, setModefiedSchema] = useState();
    const [isEmpty, setIsEmpty] = useState();

    const setNotification = useSetRecoilState(notificationState);
    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;
        async function schemaSetting() {
            let schema = await getSchema("MomSysUdtCompany");
            if(mounted) {
                schema.columns.forEach(column => schemaColumnSetting(column));
                setSchema(schema);

                let modifiedSchema = cloneDeep(schema);
                modifiedSchema.formGroups = ["form.udtCompany.groupName.excelFile"];
                modifiedSchema.columns.forEach(column => columnSetting(column));
                setModefiedSchema(modifiedSchema);
            }

            function schemaColumnSetting(column) {
                if(column.name === "excelFile") {
                    column.hideInForm = true;
                    column.required = false;
                }
            }
            
            function columnSetting(column) {
                if(column.key === "PRI") {
                    column.defaultValue = "pri";
                }
    
                if(column.name !== "excelFile") {
                    column.hideInForm = true;
                    column.required = false;
                } else {
                    column.hideInForm = false;
                }
            }
        }

        schemaSetting();

        return (() => {
            mounted = false;
        });
    }, []);

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        masterGridSetting(grid.selectedItems[0]);
                    } else {
                        masterGridSetting([]);
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        masterGridSetting(grid.selectedItems[0]);
                    } else {
                        masterGridSetting([]);
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onLoadData = (data) => {
        setIsEmpty(data.length < 1 ? true : false)
    };

    const onModifyUrl = (url) => {
        return `${url}?excelData`;
    };

    return (
        <>
            <BasicCrudScreenType 
                id={id}
                table="MomSysUdtCompany" 
                view="MomSysVwCompany"
                headerTitle={t("term.company")}
                onApiInitialized={onApiInitialized}
                onInitialized={onInitialized} 
                onLoadData={onLoadData}
                noCreate
                noEdit
                noDelete
                noExcel
                onAppendButtonInFrontOfSearch={() => (
                    <>
                        <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                            <MomSysUdtCompanyExcelUploadButton
                                id="MomSysUdtCompanyExcelUploadButton"
                                createButtonName="excelUpload"
                                schema={modifiedSchema}
                                refresh={api}
                                onSuccess={onSuccess}
                                modifyUrlCallback={(url) => onModifyUrl(url)}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={schema && schema.name} accessMethod="GET">
                            <MomSysUdtCompanyExcelFormDownloadButton
                                id = "MomSysUdtCompanyExcelFormDownloadButton"
                                schema = {schema}
                                refresh = {api}
                                grid = {grid}
                                onSuccess = {onSuccess}
                            />
                        </AccessControl>
                        <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                            <CreateRecordButton
                                id={id}
                                schema={schema}
                                refresh={api}
                                onSuccess={onSuccess}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch?"PATCH":"PUT")}>
                            <UpdateRecordButton
                                id={id}
                                schema={schema}
                                grid={grid}
                                refresh={api}
                                onSuccess={onSuccess}
                                disabled={isEmpty ? true : false}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                            <DeleteRecordButton
                                id={id}
                                schema={schema}
                                grid={grid}
                                refresh={api}
                                color="secondary"
                                onSuccess={onSuccess}
                                onFailure={onFailure}
                                onPartialFailure={onNotifyWarning}
                                disabled={isEmpty ? true : false}
                            />
                        </AccessControl>
                    </>
                    )}
                />
        </>
    );

}

export default MomSysUdtCompany;
